function cartOrderSubjectCheckout() {
  var insuranceSelectionWithGolfer = {
    selectIds: [
      'insurance_subject_order_yearOfPurchase',
      'insurance_subject_order_dateOfPurchaseBike',
      'insurance_subject_order_usageMethodBike',
      'insurance_subject_order_securityMethodBike',
      'insurance_subject_order_dateOfPurchaseEBike',
      'insurance_subject_order_usageMethodEBike',
      'insurance_subject_order_securityMethodEBike',
      'insurance_subject_order_dateOfPurchaseScooter',
      'insurance_subject_order_usageMethodScooter',
      'insurance_subject_order_securityMethodScooter',
      'insurance_subject_order_dateOfPurchaseEScooter',
      'insurance_subject_order_usageMethodEScooter',
      'insurance_subject_order_securityMethodEScooter',
      'insurance_subject_order_dateOfPurchaseTrailer',
      'insurance_subject_order_usageMethodTrailer',
      'insurance_subject_order_securityMethodTrailer',
    ],
    submitButton: $('#calculate_insurance'),
    totalPriceValue: $('#total-price-value'),
    phoneInput: $('#insurance_order_phoneNumber'),
    submitOnChange: $('.insurance-submit-on-change'),
    upperCase: $('.uppercase'),
    onlyNumbers: $('.only-numbers'),
    formatNumbers: $('.format-numbers'),
    removeSpace: $('.remove-space'),
    selectBox: $('#insurance_subject_order_manufacturerBike'),
    customSelect: $('.custom-select'),
    submitAndCreateNewButton: $('#submit-and-create-new'),
    phonePrefixAdded: false,
    request: null,
    removeLinks: $('.remove-order-link'),
    editLinks: $('.edit-order-link'),

    init: function () {
      this.form = this.submitButton.closest('form');
      var request = this.request;
      var submitForm = false;
      let redirectButton = false;

      var app = this;
      this.submitButton.on('click', function (event) {
        event.preventDefault();
        submitForm = true;
        redirectButton = false;
        app.submitForm(
          app.form.serialize(),
          request,
          submitForm,
          event.target,
          redirectButton
        );
      });
      this.submitOnChange.on('change', function (event) {
        event.preventDefault();
        submitForm = false;
        redirectButton = false;
        app.submitForm(
          app.form.serialize(),
          request,
          submitForm,
          event.target,
          redirectButton
        );
      });
      this.submitAndCreateNewButton.on('click', function (event) {
        event.preventDefault();
        submitForm = true;
        redirectButton = $('#redirect_button');
        app.submitForm(
          app.form.serialize(),
          request,
          submitForm,
          event.target,
          redirectButton
        );
      });
      if ($('#order-button-type').length) {
        this.removeLinks.each(function () {
          $(this).on('click', function (event) {
            event.preventDefault();
            $('#order-temp-id').attr('value', $(this).data('id'));
            $('#order-button-type').attr('value', 'remove');
            submitForm = true;
            redirectButton = $('#remove_button');
            app.submitForm(
              app.form.serialize(),
              request,
              submitForm,
              event.target,
              redirectButton
            );
          });
        });
        this.editLinks.each(function () {
          $(this).on('click', function (event) {
            event.preventDefault();
            $('#order-temp-id').attr('value', $(this).data('id'));
            $('#order-button-type').attr('value', 'update');
            submitForm = true;
            redirectButton = $('#edit_button');
            app.submitForm(
              app.form.serialize(),
              request,
              submitForm,
              event.target,
              redirectButton
            );
          });
        });
      }
      /*      $('select').each(function (event) {
              $(this).trigger('change');
              event.preventDefault();
              submitForm = false;
              app.submitForm(app.form.serialize(), request, submitForm, event.target);
            });*/

      this.upperCase.keyup(function () {
        $(this).val($(this).val().toUpperCase());
      });
      this.onlyNumbers.keyup(function () {
        $(this).val($(this).val().replace(/\D/g, ''));
      });
      this.formatNumbers.keyup(function () {
        $(this).val($(this).val().replace(/\D/g, ''));

        // var nStr = $(this).val();
        // x = nStr.split('.');
        // x1 = x[0];
        // x2 = x.length > 1 ? ' ' + x[1] : '';
        // var rgx = /(\d+)(\d{3})/;
        // while (rgx.test(x1)) {
        //   x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        // }
        // $(this).val(x1 + x2);
      });
      this.removeSpace.keyup(function () {
        $(this).val($(this).val().replace(/\s/g, ''));
      });
      this.selectBox.on('change', function (event) {
        $('.error-select-box').remove();
        $('.select2-selection--single').removeClass('error');
      });
      this.customSelect.on('click', function (event) {
        if ($(this).find('.insurance-submit-on-change').val() != '') {
          app.submitForm(
            app.form.serialize(),
            request,
            submitForm,
            event.target,
            redirectButton
          );
        }
        // console.log($(this).find('.insurance-submit-on-change').val());
      });
    },
    submitForm: function (
      serializedForm,
      request,
      submitForm,
      targetElement,
      redirectButton
    ) {
      var app = this;
      if (request !== null) {
        request.abort();
      }
      request = $.ajax({
        url: this.form.attr('action'),
        method: 'POST',
        data: serializedForm,
        beforeSend: function () {
          console.log(serializedForm);
          // app.disableButton(true);
        },
        success: function (response) {
          var responseObject = $.parseJSON(response);
          console.log(responseObject);
          app.showTotalPrice(responseObject);
          app.showCoupon(responseObject);
          $('.pricing-with-golfer-input').removeClass('is-danger');
          $('.select2-selection--single').removeClass('is-danger');
          $('.insurance-submit-on-change').removeClass('is-danger');
          $('.select-selected').removeClass('is-danger');
          $('.form-error').remove();
          if (
            (responseObject.ok || responseObject.isOk) &&
            responseObject.errors.length === 0
          ) {
            if (submitForm) {
              // app.submitButton.trigger('click');
              if (redirectButton) {
                redirectButton.click();
              } else {
                app.submitFormDefault();
              }
            } else {
            }
            if (targetElement.id === 'personal_information_smsCode') {
              app.submitFormWithSmsCode();
            }
          } else {
            app.displayErrors(responseObject.errors, submitForm, targetElement);
          }
        },
        error: function (xhr, status, error) {
          var err = eval('(' + xhr.responseText + ')');
          alert(err.Message);
          app.showMessage(xhr.responseText, 'error');
        },
        complete: function () {
          app.enableButton();
        },
      });
    },
    showMessage: function (message, type) {
      console.log(message + ' ' + type);
    },
    displayErrors: function (errors, submitForm, targetElement) {
      var app = this;
      if (submitForm) {
        $.each(errors, function (key, value) {
          var element = $('#insurance_subject_order_' + key);
          if (
            'insurance_subject_order_' + key ===
            'insurance_subject_order_phoneNumber'
          ) {
            element
              .parent()
              .after(
                '<p class="form-error" id="first-error">' + value + '</p>'
              );
          } else if (app.selectIds.includes('insurance_subject_order_' + key)) {
            element
              .parent()
              .after(
                '<p class="form-error" id="first-error">' + value + '</p>'
              );
            element.next('.select-selected').addClass('is-danger');
          } else {
            element.after(
              '<p class="form-error" id="first-error">' + value + '</p>'
            );
          }

          element.addClass('is-danger');
          // return false;
        });

        // console.log(this.selectBox.find(':selected').val());
        // if (this.selectBox.find(':selected').val() === '') {
        //   this.selectBox.parent().after(
        //     '<p class="form-error error-select-box" id="first-error">' +
        //       this.selectBox.data('error') +
        //       '</p>'
        //   );
        //   $('.select2-selection--single').addClass('is-danger');
        // }

        $('html, body').animate(
          {
            scrollTop: $('#first-error').offset().top - 180,
          },
          1000
        );
      } else {
        $.each(errors, function (key, value) {
          var element = $('#insurance_subject_order_' + key);
          if ('insurance_subject_order_' + key === targetElement.id) {
            if (
              'insurance_subject_order_' + key ===
              'insurance_subject_order_phoneNumber'
            ) {
              element
                .parent()
                .after(
                  '<p class="form-error" id="first-error">' + value + '</p>'
                );
            } else if (
              app.selectIds.includes('insurance_subject_order_' + key)
            ) {
              element
                .parent()
                .after(
                  '<p class="form-error" id="first-error">' + value + '</p>'
                );
              element.next('.select-selected').addClass('is-danger');
            } else {
              element.after(
                '<p class="form-error" id="first-error">' + value + '</p>'
              );
            }

            element.addClass('is-danger');
          }
        });
      }
    },
    showTotalPrice: function (responseObject) {
      if (responseObject.transformedOrder) {
        $('#total-price-value').text(
          responseObject.transformedOrder.totalPriceCZK + ' Kč'
        );
      }
    },
    showCoupon: function (responseObject) {
      var couponBlock = $('.coupon-info-js');
      couponBlock.hide();
      $('#select-payment-section').show();
      $('.total-price').data('coupon-value', 0).data('coupon-type', 0);
      if (
        responseObject.transformedOrder &&
        responseObject.transformedOrder.coupon
      ) {
        var coupon = responseObject.transformedOrder.coupon;
        $.each(coupon.addProducts, function () {
          $('#summary-list').append(
            '<li class="arrange--summary--li coupon-info-js">\n' +
              '                                      <div class="arrange--summary--icon">\n' +
              '                                          <span>+</span>\n' +
              '                                      </div>\n' +
              '                                      <div class="arrange--summary--content">\n' +
              '                                          <div class="arrange--summary--content--price">Kupón</div>\n' +
              '                                          <p class="arrange--summary--content--text">' +
              this.checkoutDescriptionCs +
              '</p>\n' +
              '                                      </div>\n' +
              '                                  </li>'
          );
        });
        if (coupon.discountType === 1 || coupon.discountType === 2) {
          couponBlock.show();
          $('.total-price')
            .text(responseObject.transformedOrder.totalPriceCZK + ' Kč/rok')
            .data('coupon-value', coupon.valueCZK)
            .data('coupon-type', coupon.discountType);
          // $('#coupon-price-before').text('Původně ' + responseObject.transformedOrder.productsPriceCZK + ' Kč');
          $('#coupon-value').text(
            'Sleva ' + responseObject.transformedOrder.discountValueCZK + ' Kč'
          );

          if (
            (responseObject.transformedOrder.csOrder &&
              responseObject.transformedOrder.totalPriceCZK === 0) ||
            (!responseObject.transformedOrder.csOrder &&
              responseObject.transformedOrder.totalPriceEUR === 0)
          ) {
            $('#select-payment-section').hide();
          }
        }
        if (coupon.discountType === 3) {
          couponBlock.show();
          let totalPricejQuery = $('.total-price');
          let freeMonths = coupon.freeMonths;
          totalPricejQuery.text(
            responseObject.transformedOrder.totalPriceCZK +
              ' Kč/rok + ' +
              freeMonths +
              ' měsíců zdarma'
          );
        }
      }
    },
    disableButton: function () {
      this.submitButton.attr('disabled', 'disabled');
    },
    enableButton: function () {
      this.submitButton.attr('disabled', false);
    },
    submitFormDefault: function (submitForm) {
      // if (this.selectBox.find(':selected').val() === '') {
      //   this.selectBox.after(
      //     '<p class="form-error error-select-box" id="first-error">' +
      //       this.selectBox.data('error') +
      //       '</p>'
      //   );
      //   $('.select2-selection--single').addClass('error');
      //
      //   $('html, body').animate(
      //     {
      //       scrollTop: $('#first-error').offset().top - 180,
      //     },
      //     1000
      //   );
      //
      //   return;
      // }
      this.form.submit();
    },
  };

  $(function () {
    insuranceSelectionWithGolfer.init();
    // var text = new NumericInput(
    //   document.getElementById('insurance_subject_order_purchasePrice'),
    //   'cs-CZ'
    // );
  });

  $(function () {
    $('#insurance_selection_with_golfer_dateOfBirth').datetimepicker({
      format: 'DD.MM.YYYY',
      locale: 'cs',
    });

    var inputLocale = $('#input-locale').val();
    $('#insurance_selection_with_golfer_golfClub').select2({
      language: {
        noResults: function () {
          if (inputLocale === 'en') {
            return 'No results found';
          } else {
            return 'Nenalezeny žádné položky.';
          }
        },
      },
    });

    var updateInsuranceInput = $('#update-insurance-input');
    var updateInsuranceInputMinDate = $('#update-insurance-input-min-date');
    var changeInsuranceInput = $('#change-insurance-input');
    var changeInsuranceInputMinDate = $('#change-insurance-input-min-date');
    if (updateInsuranceInput.length !== 0) {
      $('#insurance_selection_with_golfer_timeToProcess').datetimepicker({
        format: 'DD.MM.YYYY',
        locale: 'cs',
        useCurrent: false,
        minDate: moment(updateInsuranceInputMinDate.val(), 'DD.MM.YYYY'),
        defaultDate: moment(updateInsuranceInput.val(), 'DD.MM.YYYY'),
      });
    } else if (changeInsuranceInput.length !== 0) {
      $('#insurance_selection_with_golfer_timeToProcess').datetimepicker({
        format: 'DD.MM.YYYY',
        locale: 'cs',
        useCurrent: false,
        minDate: moment(changeInsuranceInputMinDate.val(), 'DD.MM.YYYY'),
        defaultDate: moment(changeInsuranceInput.val(), 'DD.MM.YYYY'),
      });
    } else {
      $('#insurance_selection_with_golfer_timeToProcess').datetimepicker({
        format: 'DD.MM.YYYY',
        locale: 'cs',
        minDate: moment().add(1, 'day'),
      });
    }
  });

  // function NumericInput(inp, locale) {
  //   var numericKeys = '0123456789';
  //
  //   // restricts input to numeric keys 0-9
  //   inp.addEventListener('keypress', function (e) {
  //     var event = e || window.event;
  //     var target = event.target;
  //
  //     if (event.charCode == 0) {
  //       return;
  //     }
  //
  //     if (-1 == numericKeys.indexOf(event.key)) {
  //       // Could notify the user that 0-9 is only acceptable input.
  //       event.preventDefault();
  //       return;
  //     }
  //   });
  //
  //   // add the thousands separator when the user blurs
  //   inp.addEventListener('blur', function (e) {
  //     console.log('test');
  //     var event = e || window.event;
  //     var target = event.target;
  //
  //     console.log(target.value);
  //     var tmp = target.value.replace(/,/g, '');
  //     var val = Number(tmp).toLocaleString(locale);
  //
  //     if (tmp == '') {
  //       target.value = '';
  //     } else {
  //       target.value = val;
  //     }
  //   });
  //
  //   // strip the thousands separator when the user puts the input in focus.
  //   inp.addEventListener('focus', function (e) {
  //     console.log('test2');
  //
  //     var event = e || window.event;
  //     var target = event.target;
  //     console.log(target.value);
  //     var val = target.value.replace(/[,.]/g, '');
  //
  //     target.value = val;
  //   });
  // }

  function setActivePricingValue($element, baseClass, tabId, inputName) {}

  $(document).ready(function () {});
}
